export type EventAction = 'delete' | 'cancel' | 'edit' | 'pair' | 'postpone';

export interface EventActionSource {
  status: string;
  cancellable: boolean;
  deletable: boolean;
  postponable: boolean;
}

const DRAFT_STATUS = 'draft';
const CANCELLED_STATUS = 'cancelled';

export function isEventActionAllowed(
  action: EventAction,
  source: EventActionSource | null | undefined,
  canWrite: boolean,
): boolean {
  if (!canWrite || !source) {
    return false;
  }

  switch (action) {
    case 'delete':
      return source.deletable;
    case 'cancel':
      return source.cancellable;
    case 'postpone':
      return source.postponable;
    case 'edit':
      return source.status === DRAFT_STATUS || source.postponable;
    case 'pair':
      return source.status !== CANCELLED_STATUS;
  }
}
